import type { CaseFile } from "@/domains/cases/api/types";

export const SEED_CASES: ReadonlyArray<CaseFile> = [
  {
    id: "case-9214",
    number: "9214",
    title: "Overlast De Coninckplein",
    status: "active",
    requestId: "req-9214",
    managerId: "u-lien",
    managerName: "Lien Vandevelde",
    startDate: "2026-05-05",
    endDate: "2026-05-19",
    address: "De Coninckplein 1, 2060 Antwerpen",
    district: "Antwerpen-Noord",
    reason:
      "Aanhoudende overlast (drugs- en geluidsmeldingen) sinds 4 maanden — gestructureerde observatie nodig.",
    assetIds: ["ast-c-001", "ast-bp-001"],
    notes: [
      {
        id: "note-9214-1",
        authorId: "u-lien",
        authorName: "Lien Vandevelde",
        createdAt: "2026-05-04T09:30:00",
        content:
          "Plaatsing op bestaande paal, akkoord met dienst openbare werken op 03/05. Plaatsing voorzien op 05/05 in de voormiddag.",
        scope: "case",
      },
      {
        id: "note-9214-2",
        authorId: "u-jeroen",
        authorName: "Jeroen Vermeer",
        createdAt: "2026-05-05T11:14:00",
        content: "Camera geplaatst en uitgelijnd richting Lange Beeldekensstraat. Foto's toegevoegd.",
        scope: "asset",
        assetId: "ast-c-001",
      },
    ],
    history: [
      {
        id: "h-9214-1",
        timestamp: "2026-04-28T09:14:00",
        actorId: "u-maarten",
        actorName: "Maarten Hendrickx",
        type: "created",
        description: "Aanvraag AANV-2026-9214 ingediend.",
      },
      {
        id: "h-9214-2",
        timestamp: "2026-04-29T10:02:00",
        actorId: "u-lien",
        actorName: "Lien Vandevelde",
        type: "statusChanged",
        description: "Status gewijzigd naar 'In behandeling'.",
      },
      {
        id: "h-9214-3",
        timestamp: "2026-04-30T14:21:00",
        actorId: "u-lien",
        actorName: "Lien Vandevelde",
        type: "assetAdded",
        description: "Camera MC-001 toegevoegd aan dossier.",
      },
      {
        id: "h-9214-4",
        timestamp: "2026-04-30T14:22:00",
        actorId: "u-lien",
        actorName: "Lien Vandevelde",
        type: "assetAdded",
        description: "Batterij pack BP-001 toegevoegd aan dossier.",
      },
      {
        id: "h-9214-5",
        timestamp: "2026-04-30T14:30:00",
        actorId: "u-lien",
        actorName: "Lien Vandevelde",
        type: "mailSent",
        description: "E-mail 'Plaatsing gepland' verzonden naar Vermeer Mobiele Camerasystemen BV.",
      },
      {
        id: "h-9214-6",
        timestamp: "2026-05-05T11:14:00",
        actorId: "u-jeroen",
        actorName: "Jeroen Vermeer",
        type: "taskCompleted",
        description: "Taak 'Camera plaatsen' afgevinkt.",
      },
    ],
  },
  {
    id: "case-9221",
    number: "9221",
    title: "Cameratoezicht Groenplaats",
    status: "scheduled",
    requestId: "req-9221",
    managerId: "u-lien",
    managerName: "Lien Vandevelde",
    startDate: "2026-05-08",
    endDate: "2026-05-15",
    address: "Groenplaats, 2000 Antwerpen",
    district: "Antwerpen-Centrum",
    reason: "Preventief cameratoezicht tijdens festivalseizoen.",
    assetIds: ["ast-c-004"],
    notes: [],
    history: [
      {
        id: "h-9221-1",
        timestamp: "2026-05-02T11:42:00",
        actorId: "u-maarten",
        actorName: "Maarten Hendrickx",
        type: "created",
        description: "Aanvraag AANV-2026-9221 ingediend.",
      },
    ],
  },
  {
    id: "case-9223",
    number: "9223",
    title: "Camera Sint-Jansvliet",
    status: "active",
    requestId: "req-9223",
    managerId: "u-lien",
    managerName: "Lien Vandevelde",
    startDate: "2026-05-04",
    endDate: "2026-05-18",
    address: "Sint-Jansvliet 19, 2000 Antwerpen",
    district: "Antwerpen-Zuid",
    reason: "Gerichte observatie i.k.v. lopend gerechtelijk onderzoek.",
    assetIds: ["ast-c-008"],
    notes: [],
    history: [],
  },
  {
    id: "case-9225",
    number: "9225",
    title: "Mobile tree Operaplein",
    status: "active",
    requestId: "req-9225",
    managerId: "u-lien",
    managerName: "Lien Vandevelde",
    startDate: "2026-05-09",
    endDate: "2026-05-23",
    address: "Operaplein, 2018 Antwerpen",
    district: "Antwerpen-Centrum",
    reason: "Cameratoezicht tijdens Sinksenfoor opstart.",
    assetIds: ["ast-mt-001", "ast-bp-004"],
    notes: [],
    history: [],
  },
  {
    id: "case-9227",
    number: "9227",
    title: "Camcar Sportpaleis",
    status: "scheduled",
    requestId: "req-9227",
    managerId: "u-lien",
    managerName: "Lien Vandevelde",
    startDate: "2026-05-11",
    endDate: "2026-05-13",
    address: "Schijnpoortweg 119, 2170 Merksem",
    district: "Borgerhout",
    reason: "Crowd management concert grote zaal.",
    assetIds: ["ast-cc-001"],
    notes: [],
    history: [],
  },
  {
    id: "case-9229",
    number: "9229",
    title: "ANPR-trailer Singel",
    status: "active",
    requestId: "req-9229",
    managerId: "u-lien",
    managerName: "Lien Vandevelde",
    startDate: "2026-05-01",
    endDate: "2026-05-15",
    address: "Singel 25, 2018 Antwerpen",
    district: "Antwerpen-Zuid",
    reason: "ANPR-controle in kader van mobiliteitsplan.",
    assetIds: ["ast-tr-001"],
    notes: [],
    history: [],
  },
  {
    id: "case-9199",
    number: "9199",
    title: "Afgerond — Park Spoor Noord",
    status: "closed",
    requestId: "req-9199",
    managerId: "u-lien",
    managerName: "Lien Vandevelde",
    startDate: "2026-03-10",
    endDate: "2026-04-08",
    address: "Park Spoor Noord, 2060 Antwerpen",
    district: "Antwerpen-Noord",
    reason: "Maandelijkse evaluatie cameratoezicht park.",
    assetIds: [],
    notes: [],
    history: [
      {
        id: "h-9199-1",
        timestamp: "2026-04-09T16:00:00",
        actorId: "u-lien",
        actorName: "Lien Vandevelde",
        type: "statusChanged",
        description: "Dossier afgesloten en gearchiveerd.",
      },
    ],
  },
];
